<template>
    <div class="p-2">
        <div>
            <input class="mb-6" type="file"
                @input="inputHandle"
            >
        </div>
        
        <div class="tab">
            <ul>
                <li :class="{'select': tab === 'intake'}"
                    @click="()=>{ tab = 'intake'}">
                    受理單
                </li>
                
                 <li :class="{'select': tab === 'medical'}"
                    @click="()=>{ tab = 'medical'}">
                    病歷
                </li>
            </ul>
        </div>
        
        <div v-if="tab==='intake'"
            class="card"
        >
            <div class="card-header">
                <h1>受理單匯入</h1>
            </div>
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">id</th>
                            <th scope="col">受理單編號(serial_no)</th>
                            <th scope="col">受理日期(accept_date)</th>
                            <th scope="col">物種類別id(species_category_id)</th>
                            <th scope="col">物種id(species_id)</th>
                            <th scope="col">通報人名稱(reporter_name)</th>
                            <th scope="col">通報人類型(1:公部門,2:私人)(reporter_type)</th>
                            <th scope="col">同通報人 true:false(same_reporter_tag)</th>
                            <th scope="col">拾獲人(finder)</th>
                            <th scope="col">聯絡方式(contact)</th>
                            <th scope="col">拾獲日期(find_date)</th>
                            <th scope="col">拾獲城市(find_addr_city)</th>
                            <th scope="col">拾獲區域(find_addr_district)</th>
                            <th scope="col">拾獲地址(find_addr_address)</th>
                            <th scope="col">救援原因id(rescure_reason_id)</th>
                            <th scope="col">動物攻擊種類id(attacked_type_id)</th>
                            <th scope="col">人為原因id(raising_type_id)</th>
                            <th scope="col">狀況描述(description)</th>
                            <th scope="col">受理單狀態(status_id)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(intake,index) in intakeJsonData" :key="index"
                            :class="{'import_ok': intake.id}"
                        >
                            <th scope="row">{{ intake.id }}</th>
                            <td>{{ intake.serial_no }}</td>
                            <td>{{ intake.accept_date }}</td>
                            <td>{{ intake.species_category_id }}</td>
                            <td>{{ intake.species_id }}</td>
                            <td>{{ intake.reporter_name }}</td>
                            <td>{{ intake.reporter_type }}</td>
                            <td>{{ intake.same_reporter_tag }}</td>
                            <td>{{ intake.finder }}</td>
                            <td>{{ intake.contact }}</td>
                            <td>{{ intake.find_date }}</td>
                            <td>{{ intake.find_addr_city }}</td>
                            <td>{{ intake.find_addr_district }}</td>
                            <td>{{ intake.find_addr_address }}</td>
                            <td>{{ intake.rescure_reason_id }}</td>
                            <td>{{ intake.attacked_type_id }}</td>
                            <td>{{ intake.raising_type_id }}</td>
                            <td>{{ intake.description }}</td>
                            <td>{{ intake.status_id }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="tab==='medical'"
            class="card"
        >
            <div class="card-header">
                <h1>病例匯入</h1>
            </div>
            
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">id</th>
                            <th scope="col">病歷編號(serial_no)</th>
                            <th scope="col">受理單id(acknowledgment_id)</th>
                            <th scope="col">受理單編號(acknowledgment_serial_no)</th>
                            <th scope="col">物種類別id(species_category_id)</th>
                            <th scope="col">物種id(species_id)</th>
                            <th scope="col">晶片/腳環/發報器(tracking_device_sn)</th>
                            <th scope="col">獸醫師(main_doctor)</th>
                            <th scope="col">動物別名(alias_name)</th>
                            <th scope="col">特徵(characteristics)</th>
                            <th scope="col">性別(gender_id)</th>
                            <th scope="col">院內位置(location_id)</th>
                            <th scope="col">最後體重(latest_weight)</th>
                            <th scope="col">懷孕狀態(pregnancy_status=1:未懷孕,2:懷孕中,3:哺乳中)</th>
                            <th scope="col">檢傷id(ftm_id)</th>
                            <th scope="col">完整檢傷結果(complete_result_note)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(medical,index) in medicalJsonData" :key="index"
                            :class="{'import_ok': medical.id}"
                        >
                            <th scope="row">{{ medical.id }}</th>
                            <td>{{ medical.serial_no }}</td>
                            <td>{{ medical.acknowledgment_id }}</td>
                            <td>{{ medical.acknowledgment_serial_no }}</td>
                            <td>{{ medical.species_category_id }}</td>
                            <td>{{ medical.species_id }}</td>
                            <td>{{ medical.tracking_device_sn }}</td>
                            <td>{{ medical.main_doctor }}</td>
                            <td>{{ medical.alias_name }}</td>
                            <td>{{ medical.characteristics }}</td>
                            <td>{{ medical.gender_id }}</td>
                            <td>{{ medical.location_id }}</td>
                            <td>{{ medical.latest_weight }}</td>
                            <td>{{ medical.pregnancy_status }}</td>
                            <td :class="{'text-danger': medical.ftm_id !== null }">
                                {{ medical.ftm_id === null && medical.complete_result_note !== '' ? '匯入失敗' : medical.ftm_id  }}
                            </td>
                            <td>{{ medical.complete_result_note }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        
            
        </div>
        <button type="button" class="mb-6"
            >開始匯入</button>
    </div>
    
</template>
<script>
import * as XLSX from 'xlsx';
export default {
name:'intake-import',
props:{
    
},
data(){
    const statusList = this.$parameters.statusList
    return {
        tab: 'medical',
        SpeciesCategoryList: [],
        parameterOptions: [],
        statusList: statusList,
        intakeList: [],
        medicalList:[],
        doctorList: [],
        intakeJsonData: [],
        medicalJsonData: [],
        updateIntakeJsonData: [],
    }
},
methods:{
    async initView(){

        this.$store.state.loadingStatus = true
        const scRes = await this.$api.species.getSpeciesCategoryByName({
            name: '',
            columeName: 'create_time',
            orderby: 'DESC'
        });
        this.$store.state.loadingStatus = false
        if ( scRes.code !== 200){
            return alert('取得物種分類列表失敗')
        }
        this.SpeciesCategoryList = scRes.data

        for (let index = 0; index < this.SpeciesCategoryList.length; index++) {
            const speciesCategory = this.SpeciesCategoryList[index];
            this.$store.state.loadingStatus = true
            const sRes = await this.$api.species.getSpeciesByNameAndSpeciesCategoryId({
                species_category_id: speciesCategory.id,
                name: '',
                columeName: 'create_time',
                orderby: 'DESC'
            })
            this.$store.state.loadingStatus = false
            if ( sRes.code !== 200){
                return alert(`取得物種分類[${speciesCategory.id}-${speciesCategory.name}]列表失敗`)
            }

            this.SpeciesCategoryList[index].speciesList = sRes.data
        }

        const pRes = await this.$api.parameters.getParameterOptions()
        this.$store.state.loadingStatus = false
        if ( pRes.code !== 200 ){
            return alert('取得參數列表失敗')
        }
        this.parameterOptions = pRes.data

        //一次取得所有受理單
        this.$store.state.loadingStatus = true
        const intakeRes = await this.$api.intake.acknowledgmentFormByKeywordWithPage({
            keyword: '',
            columeName: 'accept_date',
            orderby: 'DESC',
            page_size: 99999,
            page_start: 1,
            page_end: 1,
        });
        this.$store.state.loadingStatus = false

        if ( intakeRes.code !== 200 ){
            return
        }

        this.intakeList = intakeRes.data.list

        //拿到所有病歷
        this.$store.state.loadingStatus = true
        const medicalRes = await this.$api.medical.getMedicalrecordByKeywordWithPage({
            keyword: '25',
            columeName: 'create_time',
            orderby: 'DESC',
            page_size: 99999,
            page_start: 1,
            page_end: 99999,
        });
        this.$store.state.loadingStatus = false
        if ( medicalRes.code !== 200 ){
            return
        }

        this.medicalList = medicalRes.data.list
        //取得獸醫師清單
        this.$store.state.loadingStatus = true
        this.$api.users.getAccountMainDoctor().then((res)=>{
            if ( res.code !== 200 ){
                return
            }
            this.doctorList = res.data
            //這裡之後要處理建立的時候要有預設值
        })
        this.$store.state.loadingStatus = false

    },
    inputHandle(event){
        const file = event.target.files[0];
        try {
            // 使用 FileReader 讀取檔案
            const reader = new FileReader();
            reader.onload = async (e) => {
                this.readExcelDataToJsonData(e.target.result)
            };
            reader.readAsArrayBuffer(file);
        } catch (error) {
            console.error('讀取 Excel 檔案失敗:', error);
        }
    },
    async readExcelDataToJsonData(fileData){
        const data = new Uint8Array(fileData);
        this.workbook = XLSX.read(data, { type: 'array' });
        
        // 取得受理單資料表
        const intakeSheet = this.workbook.SheetNames[0];
        const intakeWorksheet = this.workbook.Sheets[intakeSheet];
        const intakeJsonData = XLSX.utils.sheet_to_json(intakeWorksheet, { header: 1 }); // header: 1 表示使用陣列格式
        //匯入入受理單
        await this.importExcelAknowledgmentForm(intakeJsonData) 
        //取得病歷資料表
        const medicalSheet = this.workbook.SheetNames[1];
        const medicalWorksheet = this.workbook.Sheets[medicalSheet];
        const medicalJsonData = XLSX.utils.sheet_to_json(medicalWorksheet, { header: 1 }); // header: 1 表示使用陣列格式
        await this.importExcelMedicalForm(medicalJsonData)
        // //新增檢傷
        await this.insetInitExamine()
    },
    async insetInitExamine(){
        for (let index = 0; index < this.medicalJsonData.length; index++) {

            

            const medical = this.medicalJsonData[index];

            if ( 
                medical.complete_result_note.trim() !== '' &&
                medical.acknowledgment_id !== null &&
                medical.id !== null
            ){

                console.log(`medical.acknowledgment_id=` , medical.acknowledgment_id)
                console.log(`medical=` , medical)

                let objFrom = new FormData()

                objFrom.append('acknowledgment_id', medical.acknowledgment_id )
                objFrom.append('medical_record_id',medical.id)
                objFrom.append('first_treatment_date', '1971-01-01')
                objFrom.append('doctor_id', medical.main_doctor)
                objFrom.append('first_treatment_reason_id', -1)
                objFrom.append('BW',medical.latest_weight)
                objFrom.append('BT', 0)
                objFrom.append('HR', 0)
                objFrom.append('RR', 0)
                objFrom.append('final_injury_category_id', -1)
                objFrom.append('second_injury_category_id', -1)
                objFrom.append('final_disposition_id', -1)
                objFrom.append('photo_url_json', '[]')

                objFrom.append('other_measurement_note', '')
                objFrom.append('complete_result_note', medical.complete_result_note)

                // this.medicalJsonData[index].ftm_id = index//res.data.id 
                
                this.$store.state.loadingStatus = true
                const res = await this.$api.ftm.addFirstTreatment(objFrom)
                this.$store.state.loadingStatus = false
                if ( res.code === 200){
                    this.medicalJsonData[index].ftm_id = res.data.id 
                }
                
            }

            
        }
    },
    async importExcelMedicalForm(medicalJsonData){
        for (let index = 3; index < medicalJsonData.length; index++) {
            const medical = medicalJsonData[index];
            console.log(`medical=` , medical)

            //取得受理單
            const acknowledgment = this.intakeJsonData.find(item=>item.serial_no === medical[2])
            const species_category_id = acknowledgment ? acknowledgment.species_category_id : `找不到${medical[2]}的物種類別id`
            const species_id = acknowledgment ? acknowledgment.species_id : `找不到${medical[2]}的物種id`
            let gender_id = 3 //medical[7] !== 'UN' ? (medical[7] == 'Female' ? 1 : 2) : 3
            if (medical[7] == 'Male' ){
                gender_id = 1
            }else if (medical[7] == 'Female' ){
                gender_id = 2
            }
            //取得醫師帳號id
            const doctor = this.doctorList.find(item=>item.name===medical[4])

            let data = {
                id: null,
                serial_no: medical[1], //病例編號
                acknowledgment_id: acknowledgment ? acknowledgment.id : `找不到${medical[2]}的id`, //受理單id
                acknowledgment_serial_no: acknowledgment ? acknowledgment.serial_no : `找不到${medical[2]}`, //受理單編號
                species_category_id: species_category_id , //物種類別id
                species_id: species_id, //物種id
                tracking_device_sn: medical[3] ? medical[3] : '' , //腳環發報器
                main_doctor: doctor ? doctor.id : 4,//獸醫師 `找不到醫師：${medical[4]}`
                alias_name: medical[5] ? medical[5] : '', //動物別名
                characteristics: medical[6] ? medical[6] : '', //特徵
                gender_id: gender_id, //性別
                location_id: -1,//院內位置
                latest_weight: medical[10] ? this.extractNumber(medical[10]) ? this.extractNumber(medical[10]) : 0 : 0, //最後體重
                pregnancy_status: 1,//懷孕狀態
                status_id: acknowledgment ? acknowledgment.status_id : 0,
                ftm_id: null,
                complete_result_note: medical[8] ? medical[8] : ''
            }

            this.medicalJsonData.push(data)

            // const medicalIndex = this.medicalJsonData.length-1
            // this.medicalJsonData[medicalIndex].id = index

            const addRes = await this.importMedicalForm(data)
            if ( addRes.code === 200 ){
                const medicalIndex = this.medicalJsonData.length-1
                this.medicalJsonData[medicalIndex].id = addRes.data.id
            }

        }
    },
    async importMedicalForm(data){
        let objFrom = new FormData()
        objFrom.append('acknowledgment_id',data.acknowledgment_id)    
        objFrom.append('serial_no' , data.serial_no)
        objFrom.append('main_doctor',data.main_doctor)
        objFrom.append('species_category_id', data.species_category_id)
        objFrom.append('species_id',data.species_id)
        objFrom.append('tracking_device_sn',data.tracking_device_sn)
        objFrom.append('alias_name',data.alias_name)
        objFrom.append('characteristics',data.characteristics)
        objFrom.append('gender_id',data.gender_id)
        objFrom.append('pregnancy_status',data.pregnancy_status)
        objFrom.append('location_id',data.location_id)
        objFrom.append('latest_weight',data.latest_weight)
        objFrom.append('status_id',data.status_id)
        this.$store.state.loadingStatus = true
        const res = await this.$api.medical.importMedicalrecord(objFrom)
        this.$store.state.loadingStatus = false
        
        return res
        
    },
    async importExcelAknowledgmentForm(intakeJsonData){
        for (let index = 3; index < intakeJsonData.length; index++) {
            const intake = intakeJsonData[index];
            let id = null
            //檢查現有資料是否有重複資料
            const acknowledgment_serial_no = this.intakeList.find(item=>item.acknowledgment_serial_no === intake[1].trim() )
            if ( acknowledgment_serial_no ){
                id = acknowledgment_serial_no.id
                // console.log(`acknowledgment_serial_no=` , acknowledgment_serial_no)
                // console.log(`intake=` , intake )
                // return alert(`${intake[1]} 資料庫重複`)
            }

            console.log('intake=>',intake)
            let description = intake[17] ? intake[17] : ''
            //處理物種類別
            const species_category = this.SpeciesCategoryList.find(item=>item.name===intake[3].trim())
            const species_category_id = species_category ? species_category.id : `找不到${intake[3].trim()}`
            //處理物種
            let species = null
            let species_id = null
            if (species_category){
                species = species_category.speciesList.find(item=>item.name === intake[4].trim() )
                species_id = species ? species.id : `找不到${intake[4].trim()}`
            }
            //處理救援原因
            const rescureList = this.parameterOptions[0].options
            const rescure_reason = rescureList.find(item=>item.name === intake[14])
            //處理動物攻擊
            
            const attackList = this.parameterOptions[1].options
            let attack_id = -1
            if (
                rescure_reason &&
                rescure_reason.id === 9
            ){
                const attackOption = attackList.find(item=>item.name === (intake[15] ? intake[15] : '') )
                attack_id = attackOption ? attackOption.id : -1 //`找不到${intake[15]}`
                console.log(`intake[15]=` , intake[15])
                if (
                    !attackOption
                ){
                    description = (intake[15] ? intake[15] : '') !== '' ? `${description}，動物攻擊種類「${intake[15]}」` : description
                }
            }

            //處理人為原因
            const raising_type_id = intake[16] ? this.parameterOptions[2].options[4].id : -1
            //處理狀態
            let intake_17 = intake[17]
            //是否死亡、安樂死、救援前死亡、轉院、轉送
            switch (intake[17]) {
                case '死亡':
                    intake_17 = '結案-死亡'
                    break;
                case '到院前死亡':
                    intake_17 = '結案-死亡'
                    break;
                case '安樂死':
                    intake_17 = '結案-死亡'
                    break;
                case '救援前死亡':
                    intake_17 = '結案-死亡'
                    break;
                case '轉院':
                    intake_17 = '結案-轉診'
                    break;
                case '轉送':
                    intake_17 = '結案-轉收容'
                    break;
                default:
                    break;
            }
            
            const status = this.statusList.find(item=>item.name=== intake_17)

            let data = {
                id: id,
                serial_no: intake[1], //受理單編號
                accept_date: this.excelDateToYMD(intake[2]), //受理日期
                species_category_id: species_category_id, //物種類別id
                species_id: species_id ? species_id : `找不到${intake[4].trim()}`, //物種id
                reporter_name: (intake[8] && intake[8].trim() !== '') ? intake[8].trim() : '*無填寫拾獲人', //通報人名稱
                reporter_type: intake[6] === '公' ? 1 : 2, //通報人類型(1:公部門,2:私人)
                same_reporter_tag: true, //同通報人 true:false
                finder: (intake[8] && intake[8].trim() !== '')  ? intake[8].trim() : '*無填寫拾獲人', //拾獲人
                contact: intake[9] ? intake[9] : '', //聯絡方式
                find_date: intake[10] ? this.excelDateToYMD(intake[10]) : this.excelDateToYMD(intake[2]), //拾獲日期
                find_addr_city: intake[11], //拾獲城市
                find_addr_district: intake[12], //拾獲區域
                find_addr_address: intake[13], //拾獲地址
                rescure_reason_id: rescure_reason ? rescure_reason.id : (!intake[14] ? -1 : `找不到${intake[14]}`),//救援原因id 找不到的話都填-1
                attacked_type_id: attack_id,//動物攻擊種類id
                raising_type_id: raising_type_id, //人為原因id
                description: description, //狀況描述
                status_id: status ? status.id : `找不到${intake[17]}`,//受理單狀態
            }

            //檢查是否有重複編號
            const serialData = this.intakeJsonData.find(item=>item.serial_no === intake[1])
            if (serialData){
                // data.id = serialData.id
                console.log(`serialData=` , serialData)
                console.log(`intake=` , intake )
                return alert(`${intake[1]} 匯入內容重複`)
            }

            this.intakeJsonData.push(data)

            // const intakeIndex = this.intakeJsonData.length-1
            // this.intakeJsonData[intakeIndex].id = index//addRes.data.id

            const addRes = await this.importAknowledgmentForm(data)
            if ( addRes.code === 200 ){
                const intakeIndex = this.intakeJsonData.length-1
                this.intakeJsonData[intakeIndex].id = addRes.data.id
            }

        }

        this.$store.state.actionResult.show({status:'success',massage:'讀取完成'})
    },
    async importAknowledgmentForm(data){

        if ( data.id !== null ){
            return {
                code : 200,
                data: {
                    id: data.id
                }
            }
        }
        let objFrom = new FormData()
        objFrom.append('serial_no',data.serial_no)
        objFrom.append('accept_date',data.accept_date)
        objFrom.append('species_category_id',data.species_category_id)
        objFrom.append('species_id', data.species_id)
        objFrom.append('reporter_name', data.reporter_name)
        objFrom.append('reporter_type', data.reporter_type)
        objFrom.append('same_reporter_tag', data.same_reporter_tag)
        //處理通報人等同拾獲人資料
        objFrom.append('finder', data.same_reporter_tag ? data.reporter_name : data.finder)
        
        objFrom.append('contact', data.contact)
        objFrom.append('find_date', data.find_date)
        objFrom.append('find_addr_city', data.find_addr_city)
        objFrom.append('find_addr_district', data.find_addr_district)
        objFrom.append('find_addr_address', data.find_addr_address)
        objFrom.append('gps_lng', data.gps_lng)
        objFrom.append('gps_lat', data.gps_lat)
        objFrom.append('rescure_reason_id', data.rescure_reason_id !== -1 ? data.rescure_reason_id : '' )
        objFrom.append('attacked_type_id', data.attacked_type_id !== -1 ? data.attacked_type_id : '' )
        objFrom.append('raising_type_id', data.raising_type_id !== -1 ? data.raising_type_id : '' )

        objFrom.append('description', data.description )

        objFrom.append('status_id', data.status_id )

        //開始呼叫API
        this.$store.state.loadingStatus = true
        const res = await this.$api.intake.importAknowledgmentForm(objFrom)
        this.$store.state.loadingStatus = false
        if ( res.code !== 200 ){
            this.$store.state.actionResult.show({status:'fail',massage:res.msg})
            return res
        }
        return res
    },
    excelDateToYMD(serial) {
        const utc_days = Math.floor(serial - 25569); // Excel 日期從 1900-01-01 起算，JS 從 1970-01-01 起算
        const utc_value = utc_days * 86400; // 換算成秒
        const date_info = new Date(utc_value * 1000); // 換算成毫秒

        const year = date_info.getUTCFullYear();
        const month = String(date_info.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date_info.getUTCDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    },
    /**
     * 從字串裡提取第一組整數或浮點數
     * @param {string} s 例如 "6.12kg"
     * @returns {number|null} 回傳數字或 null
     */
    extractNumber(val) {
        if (val == null) return null;
        const str = String(val).trim();

        // 1. 抓數字 + 單位（kg 或 g）
        //    (\d+(\.\d+)?)：整數或浮點
        //    \s*          ：可有空格
        //    (kg|g)       ：單位
        const m = str.match(/(\d+(\.\d+)?)(?:\s*)(kg|g)$/i);
        if (!m) return null;

        const num  = parseFloat(m[1]);
        const unit = m[3].toLowerCase();

        // 2. 如果是 kg 就 *1000，否則單位本身是 g，就直接回傳
        return unit === 'kg' ? num * 1000 : num;
    },
    async beginImport(){

    },
},
async mounted(){
   this.initView()
},
async created(){
    
}
};
</script>
<style scoped>
.import_ok{
    background-color: #ffc4c4;
}
.tab > ul{
    list-style: none;
    padding: 0;
    display: flex;
    gap: 1rem;
}
.tab > ul > li.select{
    background-color: blue;
    color: aliceblue;
}
</style>